module.exports = __webpack_public_path__ + "static/media/+2 MPC(20-06-2026).f68b0872.xlsx";